import { useQuery, useMutation } from "@tanstack/react-query"
import { fetchWithValidation } from "@app/helpers/fetchWithValidation"
import ENDPOINTS from "@app/constants/endpoints"
import {
  TwoFactorSetupDataSchema,
  TwoFactorVerifyResponseSchema,
  type TwoFactorSetupData,
  type TwoFactorVerifyResponse,
} from "../models/twoFactorSetup"

export function useTwoFactorSetup() {
  return useQuery<TwoFactorSetupData, Error>({
    queryKey: ["twoFactorSetup"],
    queryFn: () =>
      fetchWithValidation(ENDPOINTS.AUTH_SETUP_AUTHENTICATOR, TwoFactorSetupDataSchema),
    staleTime: 1000 * 60 * 5,
  })
}

export function useVerifyTwoFactorSetup() {
  return useMutation<TwoFactorVerifyResponse, Error, { code: string; secret: string }>({
    mutationFn: ({ code, secret }) =>
      fetchWithValidation(ENDPOINTS.AUTH_VERIFY_AUTHENTICATOR_SETUP, TwoFactorVerifyResponseSchema, {
        method: "POST",
        data: { code, secret },
      }),
  })
}
